export default "__VITE_ASSET__fecb4bbc__"